import { render, staticRenderFns } from "./MiniCalendar.vue?vue&type=template&id=07039f21"
import script from "./MiniCalendar.ts?vue&type=script&lang=ts&external"
export * from "./MiniCalendar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports